module.exports = __webpack_public_path__ + "assets/svg/UI/link-white-ba6192.svg";